import React from "react";

/**
 * Iter55d — Trusted Worldwide strip
 * A slim, editorial credibility band. Content is 100% CMS-driven; falls back
 * to nothing if disabled or empty (so removing the section on the CMS side is
 * a zero-code operation).
 */
const TrustedWorldwide = ({ section, countries }) => {
  const list = (countries || [])
    .filter((c) => c && c.enabled !== false && (c.name || "").trim())
    .sort((a, b) => (a.order || 0) - (b.order || 0));

  if (list.length === 0) return null;

  return (
    <section
      className="border-y border-border bg-background"
      data-testid="trusted-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex items-center gap-4 shrink-0">
          <span className="hairline-accent w-10" />
          <span className="overline text-accent">{section?.title || "Trusted worldwide"}</span>
        </div>
        <ul className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs tracking-[0.2em] uppercase text-muted-foreground">
          {list.map((c, i) => (
            <React.Fragment key={c.id || c.name}>
              {i > 0 && <span className="opacity-40" aria-hidden>·</span>}
              <li data-testid={`trusted-country-${(c.id || c.name).toString().toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                {c.name}
              </li>
            </React.Fragment>
          ))}
        </ul>
        {section?.subtitle && (
          <span className="text-xs text-muted-foreground italic md:ml-auto">{section.subtitle}</span>
        )}
      </div>
    </section>
  );
};

export default TrustedWorldwide;
